module.exports = __webpack_public_path__ + "static/media/nz.ffdb4930.svg";